"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    "default": {
      textTransform: "none",
      borderRadius: "36px",
      border: "1px solid",
      orderColor: theme.palette.primary.main
    },
    active: {
      textTransform: "none",
      borderRadius: "36px",
      border: "hidden",
      backgroundColor: theme.palette.primary.main,
      color: "white",
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      }
    }
  };
});

var QuickFilterItem = function QuickFilterItem(_ref) {
  var disabled = _ref.disabled,
      category = _ref.category,
      filterOnClick = _ref.filterOnClick;
  var classes = useStyles();
  var label = category.label,
      isActive = category.isActive;
  console.log(label, isActive);
  return /*#__PURE__*/_react["default"].createElement(_core.Button, {
    variant: "outlined",
    "data-selected": isActive,
    className: !isActive ? classes["default"] : classes.active,
    disabled: disabled,
    onClick: function onClick() {
      return filterOnClick(label);
    }
  }, label);
};

QuickFilterItem.propTypes = {
  category: _propTypes["default"].object,
  filterOnClick: _propTypes["default"]["function"],
  disabled: _propTypes["default"].bool
};
QuickFilterItem.defaultProps = {
  category: [{
    label: "Data missing",
    isActive: false
  }],
  filterOnClick: function filterOnClick() {},
  disabled: false
};
var _default = QuickFilterItem;
exports["default"] = _default;